import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import investmentService from "../../api/investmentService";

export const getinvestmentReports = createAsyncThunk(
  "frontend/get-investment-report",
  async (payload) => {
    try {
      const response = await investmentService.viewInvestmentReport(payload);

      if (response) {
        return {
          investmentReport: response?.data,
          actionFlag: "INVESTMENT_REPORT",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      console.log(error);
    }
  },
);
export const getinvestmentReportsInputs = createAsyncThunk(
  "frontend/get-investment-report-inputs",
  async (payload) => {
    try {
      const response = await investmentService.viewInvestmentInputs(payload);
      if (response) {
        return {
          investmentReportInputs: response?.data,
          actionFlag: "INVESTMENT_REPORT_INPUTS",
          success: "",
          error: "",
        };
      }
    } catch (error) {
      console.log(error);
    }
  },
);

const initialState = {
  investmentReport: {},
  investmentReportInputs: {},
  // cityItems: {},
  // stateItems: {},
  // roleItems: {},
  // actionFlag: "",
  // locationChoiceItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const investmentSlice = createSlice({
  name: "investment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getinvestmentReports.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getinvestmentReports.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.investmentReport = action.payload.investmentReport || {};
        state.successMessage =
          action.payload.message || "Successfully fetched investment report";
        state.errorMessage = "";
      })
      .addCase(getinvestmentReports.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getinvestmentReportsInputs.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getinvestmentReportsInputs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.investmentReportInputs =
          action.payload.investmentReportInputs || {};
        state.successMessage =
          action.payload.message ||
          "Successfully fetched investment report Inputs";
        state.errorMessage = "";
      })
      .addCase(getinvestmentReportsInputs.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export default investmentSlice.reducer;
